import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemEntity } from './item.entity';
import { LocationEntity } from './location.entity';
import { PurchaseOrderReceiptDetailEntity } from './purchase-order-receipt-detail.entity';
import { ShipmentDetailEntity } from './shipment-detail.entity';
import { WarehouseEntity } from './warehouse.entity';

@Index('externalId_fk_warehouse__id', ['externalId', 'fkWarehouseId'], {
	unique: true,
})
@Index('fk_warehouse__id', ['fkWarehouseId'], {})
@Index('item_lot__fk_item__id_fk', ['fkItemId'], {})
@Index(
	'item_lot_itemExternalId_deletedDate',
	['itemExternalId', 'deletedDate'],
	{},
)
@Index(
	'item_lot_externalId_fk_warehouse__id__deleted_userId',
	['deletedUserId', 'externalId', 'fkWarehouseId'],
	{},
)
@Index('idx_item_lot_location', ['fkLocationId'])
@Entity('item_lot')
export class ItemLotEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('varchar', { name: 'externalId2', nullable: true, length: 64 })
	public externalId2!: string | null;

	@Column('varchar', { name: 'itemExternalId', nullable: true, length: 64 })
	public itemExternalId!: string | null;

	@Column('int', { name: '_fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', {
		name: 'fk_warehouse__id',
		unsigned: true,
		default: () => "'1'",
	})
	public fkWarehouseId!: number;

	/** Physical location within the warehouse where this lot is stored (shelf, bin, etc.) */
	@Column('int', {
		name: 'fk_location__id',
		unsigned: true,
		nullable: true,
	})
	public fkLocationId!: number | null;

	@Column('varchar', { name: 'lotNumber', length: 255 })
	public lotNumber!: string;

	@Column('int', { name: 'quantityRemaining', nullable: true })
	public quantityRemaining!: number | null;

	@Column('date', { name: 'expirationDate', nullable: true })
	public expirationDate!: Date | null;

	@Column('datetime', { name: 'productionDate', nullable: true })
	public productionDate!: Date | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@ManyToOne(() => ItemEntity, (item) => item.itemLots, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(() => WarehouseEntity, (warehouse) => warehouse.itemLots, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_warehouse__id', referencedColumnName: 'id' }])
	public warehouse!: WarehouseEntity;

	@ManyToOne(() => LocationEntity, { createForeignKeyConstraints: false })
	@JoinColumn([{ name: 'fk_location__id', referencedColumnName: 'id' }])
	public location!: LocationEntity | null;

	@OneToMany(
		() => ShipmentDetailEntity,
		(shipmentDetail) => shipmentDetail.itemLot,
		{},
	)
	public shipmentDetails!: Array<ShipmentDetailEntity>;

	@OneToMany(
		() => PurchaseOrderReceiptDetailEntity,
		(purchaseOrderReceiptDetail) => purchaseOrderReceiptDetail.fkItemLot,
		{},
	)
	public purchaseOrderReceiptDetails!: Array<PurchaseOrderReceiptDetailEntity>;
}
